import { getCurrentConference } from '../../../react/features/base/conference/functions';
import { SUBTITLES_HIDDEN, TRANSCRIPTION_DISABLED, TRANSCRIPTION_LANGUAGE_COPIED } from './actionTypes';
export function transcriptionDisabled(disabled) {
    return {
        type: TRANSCRIPTION_DISABLED,
        isTranscriptionDisabled: disabled
    };
}
export function transcriptionLanguagesCopied(string, code) {
    return {
        type: TRANSCRIPTION_LANGUAGE_COPIED,
        transcriptionLanguageCopied: string,
        transcriptionCode: code
    };
}
export function subtitlesHidden(enabled) {
    return {
        type: SUBTITLES_HIDDEN,
        isSubtitlesHidden: enabled
    };
}
export function toggleMetaWildixTranscription(stateTranscription) {
    return async (dispatch, getState) => {
        const state = getState();
        const conference = getCurrentConference(state);
        conference?.getMetadataHandler().setMetadata('wildixMetadata', {
            transcriptionDisabledByUser: stateTranscription
        });
    };
}
export function isMetaWildixTranscriptionDisabled(state) {
    const { metadata } = state['features/base/conference'];
    // @ts-ignore
    return Boolean(metadata?.wildixMetadata?.transcriptionDisabledByUser);
}
